export const ORDER_STATUS_CREATED = "submitted";
export const ORDER_STATUS_PAID = "paid";
export const ORDER_STATUS_SHIPPED = "shipped";
export const ORDER_STATUS_ACCEPTED = "accepted";
export const ORDER_STATUS_CONFIRMED = "confirmed";
export const ORDER_STATUS_FAILED = "failed";
export const ORDER_STATUS_CANCELED = "canceled";
export const ORDER_STATUS_DELIVERED = "delivered";
export const ORDER_STATUS_IN_PROGRESS = "in progress";
export const ORDER_STATUS_CANCELLED = "cancelled";
export const ORDER_STATUS_DRAFT = "draft";
export const ORDER_STATUS_NEW = "new";
export const ORDER_STATUS_PACKED = "packed";
export const DELIVERY_DAYS = "1,2,3,4,5,6";
export const DEFAULT_DELIVERY_TIME = "10:00-18:00";
export const MORNING_DELIVERY_TIME = "10:00-12:00";
export const MORNING_DELIVERY_CHARGE = 15;

export const DELIVERY_LABELS = [
  { code: "AGFS", label: "AGFSiere (AGFS)" },
  { code: "AMSH", label: "Amsterdam hele dag (AMSH)" },
  { code: "AMSM", label: "Amsterdam middag (AMSM)" },
  { code: "AMSO", label: "Amsterdam ochtend (AMSO)" },
  { code: "DIV", label: "Divers, wordt intern geregeld hoe het weg gaat (DIV)" },
  { code: "JLVO", label: "Jimmy Loves Food opgehaald (JLVO)" },
  { code: "JLVB", label: "Jimmy Loves food gebracht (JLVB)" },
  { code: "POST", label: "Met pakketdienst mee (POST)" },
  { code: "SCH", label: "SooCool hele dag (10:00 - 18:00) (SCH)" },
  { code: "SCM", label: "SooCool middag (13:00 - 18:00) (SCM)" },
  { code: "SCO", label: "SooCool ochtend (10:00 - 12:00) (SCO)" },
  { code: "SCO2", label: "SooCool ochtend(2) (08:00 - 11:00) (SCO2)" },
  { code: "SCHR", label: "SooCool retail (08:00 - 18:00) (SCHR)" },
  { code: "RETAIL", label: "Retail (RETAIL)" },
  { code: "RTL1", label: "Retail (RTL1)" },
  { code: "RTL2", label: "Retail (RTL2)" },
  { code: "RTL3", label: "Retail (RTL3)" },
  { code: "RTL4", label: "Retail (RTL4)" },
  { code: "FBP", label: "Freshingbox 24H (FBP)" },
  { code: "FBF", label: "Freshingbox 48H (FBF)" },
  { code: "FBT", label: "Freshingbox 72H (FBT)" },
  { code: "FB24D", label: "Freshingbox 24H (09:00 - 18:00) (FB24D)" },
  { code: "FB24M", label: "Freshingbox 24H (09:00 - 12:00) (FB24M)" },
  { code: "FB24A", label: "Freshingbox 24H (13:00 - 18:00) (FB24A)" },
  { code: "FB48D", label: "Freshingbox 48H (09:00 - 18:00) (FB48D)" },
  { code: "FB48M", label: "Freshingbox 48H (09:00 - 12:00) (FB48M)" },
  { code: "FB48A", label: "Freshingbox 48H (13:00 - 18:00) (FB48A)" },
  { code: "FB72D", label: "Freshingbox 72H (09:00 - 18:00) (FB72D)" },
  { code: "FB72M", label: "Freshingbox 72H (09:00 - 12:00) (FB72M)" },
  { code: "FB72A", label: "Freshingbox 72H (13:00 - 18:00) (FB72A)" },
];

export const SOO_COOL_DELIVERY_LABELS = ["SCH", "SCM", "SCO", "SCO2", "SCHR"];
export const FRESHING_BOX_DELIVERY_LABELS = [
  "FBP",
  "FBF",
  "FBT",
  "FB24D",
  "FB24M",
  "FB24A",
  "FB48D",
  "FB48M",
  "FB48A",
  "FB72D",
  "FB72M",
  "FB72A",
];
export const MORNING_EXTRA_CHARGE_LABELS = ["SCO"];
export const RETAIL_DELIVERY_LABEL = "RETAIL";
export const JLF_PICKED_UP = "JLVO";
export const ADDITIONAL_DELIVERY_LABEL = "ADD";
export const DEFAULT_DELIVERY_LABEL_FALLBACK = "DIV";

// Order picking status constants
export const ORDER_PICKING_STATUS_IN_PROGRESS = "inProgress";
export const ORDER_PICKING_STATUS_COMPLETED = "completed";

// Change reason options
export const CHANGE_REASON_OPTIONS = [
  { value: "Customer added", label: "customer_added" },
  { value: "Customer removed", label: "customer_removed" },
];

export const COUNTRY_CODE_BELGIUM = "BE";
export const COUNTRY_CODE_NETHERLANDS = "NL";
export const COUNTRY_CODE_GERMANY = "DE";
export const COUNTRY_CODE_FRANCE = "FR";
